import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const cities = [
  { id: 'nicosia', name: 'Nicosia', nameGr: 'Λευκωσία' },
  { id: 'larnaca', name: 'Larnaca', nameGr: 'Λάρνακα' },
  { id: 'limassol', name: 'Limassol', nameGr: 'Λεμεσός' },
  { id: 'paphos', name: 'Paphos', nameGr: 'Πάφος' },
  { id: 'ammochostos', name: 'Ammochostos', nameGr: 'Αμμόχωστος' },
];

export default function FindSaltStone() {
  useEffect(() => {
    document.title = 'Find Salt & Stone';
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="find-page">
      {/* Hero Section - Same style as Home */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
        {/* Background - Salt & Stone Bottle */}
        <div className="absolute inset-0">
          {/* Mobile/Tablet bottle - Top down style */}
          <div className="lg:hidden absolute left-1/2 -translate-x-1/2 top-0 -translate-y-[40%] h-[95vh] w-[90vw]">
            <img
              src="https://customer-assets.emergentagent.com/job_60caa5be-1d50-4b72-801b-3659f641dade/artifacts/9uzc6zo8_IMG_7292.jpg"
              alt="Salt & Stone Gin Bottle"
              className="h-full w-full object-contain opacity-40"
            />
            {/* Edge fade gradients */}
            <div className="absolute inset-0 pointer-events-none" style={{
              background: 'radial-gradient(ellipse 80% 70% at center 40%, transparent 45%, #000000 85%)'
            }}></div>
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-transparent to-black"></div>
          </div>
          {/* Desktop/Laptop bottle - Right side */}
          <img
            src="https://customer-assets.emergentagent.com/job_60caa5be-1d50-4b72-801b-3659f641dade/artifacts/9uzc6zo8_IMG_7292.jpg"
            alt="Salt & Stone Gin Bottle"
            className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 h-full w-auto max-w-none object-contain opacity-80 translate-x-[10%]"
          />
          {/* Smooth blend gradients - Desktop only */}
          <div className="hidden lg:block absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/60 to-transparent"></div>
          <div className="hidden lg:block absolute inset-0 bg-gradient-to-b from-[#050505]/30 via-transparent to-[#050505]/80"></div>
          <div className="hidden lg:block absolute inset-0 bg-gradient-to-t from-[#050505]/70 via-transparent to-[#050505]/30"></div>
          {/* Mobile/Tablet gradients */}
          <div className="lg:hidden absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-transparent"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto pt-24">
          <span className="caption block mb-6 animate-fade-in opacity-0" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
            Select Your Region
          </span>
          <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl text-[#F2F0E9] mb-6 animate-fade-in opacity-0" style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}>
            Find Salt & Stone
          </h1>
          <p className="text-[#F2F0E9]/70 text-lg md:text-xl mb-12 max-w-2xl mx-auto animate-fade-in opacity-0" style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
            Choose your city to discover where to buy online or find us in store
          </p>
          
          {/* City Buttons */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-3xl mx-auto animate-fade-in opacity-0" style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}>
            {cities.map((city) => (
              <Link
                key={city.id}
                to={`/find/${city.id}`}
                className="group relative border border-[#D4AF37]/30 hover:border-[#D4AF37] bg-black/30 backdrop-blur-sm px-8 py-6 transition-all duration-500 hover:bg-[#D4AF37]/10"
                data-testid={`city-btn-${city.id}`}
              >
                <div className="flex items-center justify-center gap-3">
                  <MapPin className="w-5 h-5 text-[#D4AF37]" />
                  <div className="text-left">
                    <span className="block text-[#F2F0E9] font-medium">{city.name}</span>
                    <span className="block text-[#F2F0E9]/50 text-sm">{city.nameGr}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
